export default "__VITE_ASSET__CTBMr3T___"